var map = {
	"./0.jpg": 3853,
	"./1.jpg": 8960,
	"./School-License-1-241x300.jpg": 7074,
	"./School-Order-images-0-212x300.jpg": 4183,
	"./School-Order-images-1-212x300.jpg": 1794,
	"./School-Order-images-2-212x300.jpg": 6813,
	"./School-Order-images-3-212x300.jpg": 5824,
	"./Workshop-License-1-218x300.jpg": 1711
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9774;